import { useContext, useEffect, useRef, useState } from 'react';
import { GoogleAnalyticsContext } from '../../GoogleAnalytics';
import { Input } from '../../Input/Input';
import { useStepper } from '../../Stepper';
import invoices from '../assets/invoices.png';
import StepWrapper from './StepWrapper';

export function JobRefPage() {
  const { localData, setDataByKey, activeStepKey, gotoStep } = useStepper();
  const [error, setError] = useState('');

  const nextPage = (event) => {
    event.preventDefault();
    if (!localData.jobRef) {
      setError('Please enter a job reference number.');
    } else if (localData.jobRef.length > 35) {
      setError('Job Reference cannot exceed 35 characters.');
    } else {
      if (localData.movementType === 'Export') {
        gotoStep('8. EtaExportPort');
      } else {
        gotoStep('7. EtaPort');
      }
    }
  };

  const previousPage = () => {
    setError('');
    gotoStep('5. CategoryOfGoods');
  };

  const isInitialized = useRef(false);
  const ga = useContext(GoogleAnalyticsContext);

  useEffect(() => {
    if (ga.gaInitialized) {
      if (activeStepKey === '6. JobReference' && isInitialized.current === false) {
        isInitialized.current = true;
        window?.gtag?.('event', '6. JobReference', {
          event_category: 'EPO',
        });
      }
    }
  }, [activeStepKey, ga.gaInitialized]);

  useEffect(() => {
    setError('');
  }, [localData.jobRef]);

  return (
    <StepWrapper
      stepTitle="Your Reference"
      stepText="Your Reference"
      stepKey="6. JobReference"
      handleNextClick={nextPage}
      handleBackClick={previousPage}
      hideUnlessVisited
    >
      <div className="d-flex step-banner justify-content-center">
        <img src={invoices} width="150" height="150" alt="port" className=" mt-4 mb-4" />
      </div>
      <div className="d-flex align-self-center flex-column mt-auto  px-4" style={{ maxWidth: '400px' }}>
        <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
          Please enter your Job Reference or{' '}
        </span>
        <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
          billing ID. This will appear on all future
        </span>

        <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
          communications and sales invoices.
        </span>
      </div>
      <div className="d-flex flex-column mt-auto" style={{ paddingLeft: '6rem', paddingRight: '6rem' }}>
        <Input
          required
          label="Job Reference or Billing ID"
          name="epojobRef"
          type="text"
          value={localData.jobRef}
          data-testid="jobRef-textField"
          onChange={(e) => setDataByKey('jobRef', e.target.value)}
          className="formattedText"
        />
      </div>
      <div className="px-3 mb-3 w-75 mx-auto">
        {error && (
          <div className="alert-danger px-3 py-1 w-100 text-center" style={{ borderRadius: '10px' }}>
            {error}
          </div>
        )}
      </div>
    </StepWrapper>
  );
}
